<div class="wrapper">
    <div class="main-panel">
        <main>
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
